<template>
	<div id="login-form" v-if="auth.user == null">
    <el-form @keyup.enter.native="submitForm('loginForm')" :model="loginForm" :rules="rules" :label-position="labelPosition" ref="loginForm" label-width="100px" class="loginForm">
      <el-form-item label="Email" prop="email">
        <el-input v-model="loginForm.email"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="pass">
        <el-input v-model="loginForm.pass" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('loginForm')">Login</el-button>
        <router-link to="reset" class="alt-link">Reset Password</router-link>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { authService } from '../helpers/helpers'
export default {
  data () {
    return {
      labelPosition: 'top',
      auth: authService,
      loginForm: {
        email: '',
        pass: ''
      },
      resetForm: {
        email: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please enter you email address', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ],
        pass: [
          { required: true, message: 'Please enter your password', trigger: 'blur' },
          { min: 6, message: 'Your password is too short!' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var email = this.loginForm.email
          var pass = this.loginForm.pass
          this.auth.login(email, pass)
          this.loginForm.email = ''
          this.loginForm.pass = ''
        } else {
          console.log('There was an error!')
          return false
        }
      })
    }
  }
}
</script>
<style>

  #login-form {
    display: flex;
    align-items: center;
    min-height: 24em;
    justify-content: center;
  }

  #login-form .el-form {
    flex: 1;
    max-width: 380px;
    padding:  0 30px;
  }

  .loginForm {
    text-align: left;
  }

  .alt-link {
    text-decoration:  none;
    color:  rgb(50, 65, 87);
    display:  inline-block;
    margin-left:  15px;
  }

</style>


// WEBPACK FOOTER //
// Login.vue?540f9465